export default __webpack_public_path__ + "static/announcement-1e3991877d56e30be03d0517061225db.png";